module.exports = __webpack_public_path__ + "static/img/red_cense.3c8d89eb.png";